<template>
  <section class="relative bg-white">
    <section
      class="w-full overflow-x-auto bg-white custom-scrollbar"
      @click="
        showActions = null;
        showReasonNote = null;
      "
    >
      <table class="w-full pb-4 mt-6 bg-white min-w-max">
        <thead class="text-gray-400 bg-white border-b border-gray-200">
          <tr>
            <th class="text-sm text-left">Request Name</th>
            <th class="text-sm text-left">Employee List</th>
          </tr>
        </thead>
        <tbody v-if="!loading && overtime_request.length !== 0">
          <tr
            class="border-b h-max"
            v-for="(overtime, i) in overtime_request"
            :key="i"
          >
            <td class="p-3 text-sm">
              <p class="text-sm text-gray-400">
                {{ overtime?.type }}
              </p>
            </td>
            <td
              class="flex items-center p-3 text-sm"
              v-if="
                showModeList === 'profile' ||
                (showModeList === 'full' && showModeListIdx !== overtime.type)
              "
              @click="
                showModeList = 'full';
                showModeListIdx = overtime?.type;
              "
            >
              <template v-if="overtime?.data?.length > 0">
                <div
                  class="flex items-center justify-center w-12 h-12 duration-300 border-2 border-white rounded-full shadow-md cursor-pointer hover:z-10 hover:-mt-2 bg-zinc-400"
                  v-for="(request, i) in overtime?.data"
                  :style="`transform:translateX(${
                    i !== 0 ? `-${i * 0.5}rem` : '0'
                  })`"
                  :key="i"
                >
                  <h2 class="text-white text-md">
                    {{
                      request?.emp_id?.emp_fullname.substr(0, 1) +
                      request?.emp_id?.emp_fullname.substr(
                        request?.emp_id?.emp_fullname.indexOf(" ") + 1,
                        1
                      )
                    }}
                  </h2>
                </div>
              </template>
              <p v-else class="flex items-center h-12 text-gray-400">
                No Employment Request
              </p>
            </td>
            <td
              class="p-3 text-sm"
              @click="
                showModeList = 'profile';
                showModeListIdx = overtime.type;
              "
              v-else-if="
                showModeList === 'full' && showModeListIdx === overtime.type
              "
            >
              <template v-if="overtime?.data?.length > 0">
                <section
                  v-for="(request, i) in overtime?.data"
                  :key="i"
                  class="flex items-center mb-2 cursor-pointer"
                >
                  <div
                    class="flex items-center justify-center w-12 h-12 rounded-full shadow-md bg-zinc-400"
                  >
                    <h2 class="text-white text-md">
                      {{
                        request?.emp_id?.emp_fullname.substr(0, 1) +
                        request?.emp_id?.emp_fullname.substr(
                          request?.emp_id?.emp_fullname.indexOf(" ") + 1,
                          1
                        )
                      }}
                    </h2>
                  </div>
                  <div class="ml-5">
                    <h1
                      class="text-base text-blue-400 hover:opacity-70"
                      @click.stop="
                        assignDetailRequest(request, showModeListIdx)
                      "
                    >
                      {{ request?.emp_id?.emp_fullname }}
                    </h1>
                    <p class="mb-1 text-sm text-gray-400">
                      {{ request?.emp_id?.email }}
                    </p>
                  </div>
                </section>
              </template>

              <p v-else class="flex items-center h-12 text-gray-400">
                No Employment Request
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <NoDataShowing v-if="!loading && overtime_request.length === 0" />
    </section>
    <Loading class="mt-10" v-if="loading" />
  </section>
  <Modal
    title="Response Log"
    :showModal="showModal === 'leave'"
    @close="showModal = false"
  >
    <section class="flex justify-center w-full">
      <div>
        <h2 class="text-base">At {{ detailLeave?.empleave_apply_date }}</h2>
        <p class="text-xs text-gray-400">
          Applied by
          <span class="text-blue-400">{{
            detailLeave?.emp_id?.emp_fullname
          }}</span>
        </p>
      </div>
      <section class="relative px-10 ml-10 border-l-2 h-52">
        <div
          class="absolute top-0 flex w-10 h-10 p-2 bg-gray-100 rounded-full -left-5"
        >
          <img src="../assets/icons/log.svg" />
        </div>
        <div class="px-4 py-2 mt-10 bg-gray-100 rounded">
          <h2 class="flex items-center text-sm">
            {{ detailLeave?.empleave_type_id?.leave_name }}
            <span class="w-1.5 block h-1.5 rounded-full bg-gray-300 mx-4" />
            {{ detailLeave?.empleave_leave_duration }}
          </h2>
          <h2 class="mt-1 text-sm">
            {{ localDateString(detailLeave?.empleave_start_date) }}
            {{ detailLeave?.empleave_leave_type === "Multi Day" ? "to" : "" }}
            {{
              detailLeave?.empleave_end_date &&
              localDateString(detailLeave?.empleave_end_date)
            }}
          </h2>
          <div class="flex mt-2 text-xs text-gray-400">
            <font-awesome-icon icon="fa-file" />
            <article>
              <p class="ml-2">{{ detailLeave?.empleave_reason }}</p>
            </article>
          </div>
        </div>
      </section>
    </section>
    <section class="mt-4">
      <label class="text-sm">Response Note</label>
      <textarea rows="4" class="w-full py-4 mt-2 border outline-primary">
      </textarea>
      <section class="grid items-center grid-cols-3 mt-4">
        <p class="text-sm">Update status</p>
        <div class="flex">
          <Radio
            label="Pending"
            value="Pending"
            :checked="detailLeave?.empleave_status === 'Pending'"
            @change="detailLeave.empleave_status = 'Pending'"
          />
          <Radio
            label="Approved"
            class="mx-8"
            value="Approved"
            :checked="detailLeave?.empleave_status === 'Approved'"
            @change="detailLeave.empleave_status = 'Approved'"
          />
          <Radio
            label="Rejected"
            value="Rejected"
            :checked="detailLeave?.empleave_status === 'Rejected'"
            @change="detailLeave.empleave_status = 'Rejected'"
          />
        </div>
      </section>
    </section>
    <template #footer>
      <section class="flex justify-between w-52">
        <Button class="w-24 py-2 text-white bg-gray-400 rounded-md">
          Cancel
        </Button>
        <Button
          class="w-24 py-2 text-white bg-green-500 rounded-md"
          @click="handleEditStatus"
          :disabled="loading.edit"
        >
          Save
        </Button>
      </section>
    </template>
  </Modal>
  <Modal
    title="Response Log"
    :showModal="showModal === 'not leave'"
    @close="showModal = false"
  >
    <section
      class="flex justify-center w-full h-32"
      :class="
        data.hr?.status === 'Pending'
          ? 'pending'
          : data.hr?.status === 'Approved'
          ? 'approved'
          : 'not-approved'
      "
    >
      <div
        class="flex items-center justify-center w-10 h-10 p-2 bg-gray-100 rounded-full bg-icon"
      >
        <font-awesome-icon
          icon="fa-check"
          class="text-xl"
          v-if="data.hr?.status === 'Approved'"
        />
        <font-awesome-icon
          icon="fa-xmark"
          class="text-xl"
          v-else-if="data.hr?.status === 'Rejected'"
        />
        <font-awesome-icon icon="fa-clock" class="text-xl" v-else />
      </div>
      <section class="relative h-full px-10 ml-10 border-l-2">
        <div
          class="absolute top-0 w-3 h-3 p-2 bg-gray-100 rounded-full indicator -left-2"
        ></div>
        <div class="px-4 py-2 text-gray-400 bg-gray-100 rounded w-52">
          <p class="flex items-center text-sm">Approve HR</p>
          <!-- <p class="mt-1 text-sm">01 Dec, 22</p> -->
        </div>
      </section>
    </section>
    <section
      class="flex justify-center w-full h-32"
      :class="
        data.fsuperior?.status === 'Pending'
          ? 'pending'
          : data.fsuperior?.status === 'Approved'
          ? 'approved'
          : 'not-approved'
      "
    >
      <div
        class="flex items-center justify-center w-10 h-10 p-2 bg-gray-100 rounded-full bg-icon"
      >
        <font-awesome-icon
          icon="fa-check"
          class="text-xl"
          v-if="data.fsuperior?.status === 'Approved'"
        />
        <font-awesome-icon
          icon="fa-xmark"
          class="text-xl"
          v-else-if="data.fsuperior?.status === 'Rejected'"
        />
        <font-awesome-icon icon="fa-clock" class="text-xl" v-else />
      </div>
      <section class="relative h-full px-10 ml-10 border-l-2">
        <div
          class="absolute top-0 w-3 h-3 p-2 bg-gray-100 rounded-full indicator -left-2"
        ></div>
        <div class="px-4 py-2 text-gray-400 bg-gray-100 rounded w-52">
          <p class="flex items-center text-sm">Approve Atasan 1</p>
          <!-- <p class="mt-1 text-sm">01 Dec, 22</p> -->
        </div>
      </section>
    </section>

    <section
      class="flex justify-center w-full h-32"
      :class="
        data.ssuperior?.status === 'Pending'
          ? 'pending'
          : data.ssuperior?.status === 'Approved'
          ? 'approved'
          : 'not-approved'
      "
    >
      <div
        class="flex items-center justify-center w-10 h-10 p-2 rounded-full bg-icon"
      >
        <font-awesome-icon
          icon="fa-check"
          class="text-xl"
          v-if="data.ssuperior?.status === 'Approved'"
        />
        <font-awesome-icon
          icon="fa-xmark"
          class="text-xl"
          v-else-if="data.ssuperior?.status === 'Rejected'"
        />
        <font-awesome-icon icon="fa-clock" class="text-xl" v-else />
      </div>
      <section class="relative h-full px-10 ml-10 border-l-2">
        <div
          class="absolute top-0 w-3 h-3 p-2 bg-gray-100 rounded-full indicator -left-2"
        ></div>
        <div class="px-4 py-2 text-gray-400 bg-gray-100 rounded w-52">
          <p class="flex items-center text-sm">Approve Atasan 2</p>
          <!-- <p class="mt-1 text-sm">01 Dec, 22</p> -->
        </div>
      </section>
    </section>
    <section class="flex items-center justify-between mt-4">
      <p class="text-sm">HR Response</p>
      <div class="flex md:px-16">
        <Radio
          label="Pending"
          @change="data.hr.status = 'Pending'"
          :checked="data.hr.status === 'Pending'"
          :modelValue="data.hr.status"
          name="hr_status"
        />
        <Radio
          label="Approved"
          class="mx-8"
          @change="data.hr.status = 'Approved'"
          :checked="data.hr.status === 'Approved'"
          :modelValue="data.hr.status"
          name="hr_status"
        />
        <Radio
          label="Rejected"
          @change="data.hr.status = 'Rejected'"
          :checked="data.hr.status === 'Rejected'"
          :modelValue="data.hr.status"
          name="hr_status"
        />
      </div>
    </section>
    <section class="flex items-center justify-between mt-4">
      <p class="text-sm">
        {{ data.fsuperior?.fsuperior_id?.des_name }} Response
      </p>
      <div class="flex md:px-16">
        <Radio
          label="Pending"
          @change="data.fsuperior.status = 'Pending'"
          :checked="data.fsuperior.status === 'Pending'"
          :modelValue="data.fsuperior.status"
          name="fs_status"
        />
        <Radio
          label="Approved"
          class="mx-8"
          @change="data.fsuperior.status = 'Approved'"
          :checked="data.fsuperior.status === 'Approved'"
          :modelValue="data.fsuperior.status"
          name="fs_status"
        />
        <Radio
          label="Rejected"
          @change="data.fsuperior.status = 'Rejected'"
          :checked="data.fsuperior.status === 'Rejected'"
          :modelValue="data.fsuperior.status"
          name="fs_status"
        />
      </div>
    </section>
    <section class="flex items-center justify-between mt-4">
      <p class="text-sm">
        {{ data.ssuperior?.ssuperior_id?.des_name }} Response
      </p>
      <div class="flex md:px-16">
        <Radio
          label="Pending"
          @change="data.ssuperior.status = 'Pending'"
          :checked="data.ssuperior?.status === 'Pending'"
          :modelValue="data.ssuperior?.status"
          name="ss_status"
        />
        <Radio
          label="Approved"
          class="mx-8"
          @change="data.ssuperior.status = 'Approved'"
          :checked="data.ssuperior?.status === 'Approved'"
          :modelValue="data.ssuperior?.status"
          name="ss_status"
        />
        <Radio
          label="Rejected"
          @change="data.ssuperior.status = 'Rejected'"
          :checked="data.ssuperior?.status === 'Rejected'"
          :modelValue="data.ssuperior?.status"
          name="ss_status"
        />
      </div>
    </section>
    <template #footer>
      <section class="flex justify-between w-52">
        <Button class="w-24 py-2 text-white bg-gray-400 rounded-md">
          Cancel
        </Button>
        <Button
          class="w-24 py-2 text-white bg-green-500 rounded-md"
          @click="handleEditStatusRequest"
          :disabled="loading_request.edit"
        >
          Save
        </Button>
      </section>
    </template>
  </Modal>
</template>

<script>
import Modal from "./Modal.vue";
import Radio from "./Radio.vue";
import Button from "./Button.vue";
import { getDate } from "@/utils/getDate";
import { getCurrentTime } from "@/utils/getHours";
import { EditOvertimeRequestAPI } from "@/actions/overtime-request";
import { EditOvertimeRequestAPI as EditOutsideRequestAPI } from "@/actions/outside-request";
import Loading from "./Loading.vue";
import NoDataShowing from "./NoDataShowing.vue";
import { EditStatusLeaveRequestAPI } from "@/actions/leave-request";
import { useToast } from "vue-toastification";
import { EditOffdayRequestAPI } from "@/actions/offday";
import { EditChangeWorkshiftAPI } from "@/actions/change-shift";

export default {
  name: "TableAttadance",
  components: { Modal, Radio, Button, Loading, NoDataShowing },
  props: {
    loading: Boolean,
    overtime_request: Array,
    getNeedApproval: Function,
  },
  data() {
    return {
      showActions: null,
      showDropdown: null,
      showReasonNote: null,
      showModeList: "profile",
      showModeListIdx: null,
      showModal: false,
      loading_request: {
        edit: false,
      },
      detailLeave: {},
      data: {
        request_id: "",
        fsuperior: {
          fsuperior_id: {
            des_name: "",
          },
          status: "",
          approved_by: "",
          approved_date: "",
          approved_hours: "",
        },
        ssuperior: {
          ssuperior_id: {
            des_name: "",
          },
          approved_by: "",
          status: "",
          approved_date: "",
          approved_hours: "",
        },
        hr: {
          status: "",
          approved_by: "HR / Admin App",
          approved_date: "",
          approved_hours: "",
        },
      },
    };
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  methods: {
    showMessageStatus(response) {
      if (response.status === 200) {
        this.toast.success(response?.data?.message);
      } else {
        if (response.data.message) {
          this.toast.error(response?.data?.message);
        }
      }
    },
    localDateString(date) {
      let new_date = new Date(date);
      return new_date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    },
    formatAMPM(time) {
      let hours = parseInt(time.substr(0, 2));
      let minutes = time.substr(3, 2);
      let ampm = hours >= 12 ? "PM" : "AM";
      let formattedTime = hours + ":" + minutes + " " + ampm;
      return formattedTime;
    },
    assignDetailLeaveRequest(request) {
      this.detailLeave = request;
    },
    assignDetailOvertimeRequest(request) {
      this.data.request_id = request?._id;
      this.data.fsuperior = { ...request?.overtime_fsuperior };
      this.data.ssuperior = { ...request?.overtime_ssuperior };
      this.data.hr = { ...request?.overtime_hr };
    },
    assignDetailOutsideRequest(request) {
      this.data.request_id = request?._id;
      this.data.fsuperior = { ...request?.outside_fsuperior };
      this.data.ssuperior = { ...request?.outside_ssuperior };
      this.data.hr = { ...request?.outside_hr };
    },
    assignDetailOffdayRequest(request) {
      this.data.request_id = request?._id;
      this.data.fsuperior = { ...request?.offday_fsuperior };
      this.data.ssuperior = { ...request?.offday_ssuperior };
      this.data.hr = { ...request?.offday_hr };
    },
    assignDetailWorkshiftRequest(request) {
      this.data.request_id = request?._id;
      this.data.fsuperior = { ...request?.empchange_fsuperior };
      this.data.ssuperior = { ...request?.empchange_ssuperior };
      this.data.hr = { ...request?.empchange_hr };
    },
    assignDetailRequest(request, type) {
      this.showModal = type === "Leave Request" ? "leave" : "not leave";
      if (type === "Leave Request") {
        this.assignDetailLeaveRequest(request);
      } else if (type === "Overtime Request") {
        this.assignDetailOvertimeRequest(request);
      } else if (type === "Outside Assignment") {
        this.assignDetailOutsideRequest(request);
      } else if (type === "Change Offday") {
        this.assignDetailOffdayRequest(request);
      } else if (type === "Change Workshift") {
        this.assignDetailWorkshiftRequest(request);
      }
    },
    handleEditStatusRequest() {
      const type = this.showModeListIdx;
      if (type === "Overtime Request") {
        this.handleEditOvertimeRequest();
      } else if (type === "Outside Assignment") {
        this.handleEditOutsideRequest();
      } else if (type === "Change Offday") {
        this.handleEditOffdayRequest();
      } else if (type === "Change Workshift") {
        this.handleEditWorkshiftRequest();
      }
    },
    async handleEditOvertimeRequest() {
      this.loading_request.edit = true;
      const payload = {
        overtime_hr: {
          approved_by: "HR / Admin App",
          approved_date: getDate(),
          approved_hours: getCurrentTime(),
          status: this.data.hr.status,
        },
        overtime_fsuperior: {
          approved_by: "HR / Admin App",
          approved_date: getDate(),
          approved_hours: getCurrentTime(),
          status: this.data.fsuperior.status,
        },
        overtime_ssuperior: {
          approved_by: "HR / Admin App",
          approved_date: getDate(),
          approved_hours: getCurrentTime(),
          status: this.data.ssuperior.status,
        },
      };
      const response = await EditOvertimeRequestAPI(
        this.data?.request_id,
        payload
      );
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      if (response.status === 200) {
        this.showModal = false;
        this.getNeedApproval();
      }
      this.showMessageStatus(response);
      this.loading_request.edit = false;
    },
    async handleEditOutsideRequest() {
      this.loading_request.edit = true;
      const payload = {
        outside_hr: {
          approved_by: "HR / Admin App",
          approved_date: getDate(),
          approved_hours: getCurrentTime(),
          status: this.data.hr.status,
        },
        outside_fsuperior: {
          approved_by: "HR / Admin App",
          approved_date: getDate(),
          approved_hours: getCurrentTime(),
          status: this.data.fsuperior.status,
        },
        outside_ssuperior: {
          approved_by: "HR / Admin App",
          approved_date: getDate(),
          approved_hours: getCurrentTime(),
          status: this.data.ssuperior.status,
        },
      };
      const response = await EditOutsideRequestAPI(
        this.data?.request_id,
        payload
      );
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      if (response.status === 200) {
        this.showModal = false;
        this.getNeedApproval();
      }
      this.showMessageStatus(response);
      this.loading_request.edit = false;
    },
    async handleEditOffdayRequest() {
      this.loading_request.edit = true;
      const payload = {
        offday_hr: {
          approved_by: "HR / Admin App",
          approved_date: getDate(),
          approved_hours: getCurrentTime(),
          status: this.data?.hr?.status,
        },
        offday_fsuperior: {
          approved_by: "HR / Admin App",
          approved_date: getDate(),
          approved_hours: getCurrentTime(),
          status: this.data?.fsuperior?.status,
        },
        offday_ssuperior: {
          approved_by: "HR / Admin App",
          approved_date: getDate(),
          approved_hours: getCurrentTime(),
          status: this.data?.ssuperior?.status,
        },
      };
      const response = await EditOffdayRequestAPI(
        this.data?.request_id,
        payload
      );
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      if (response.status === 200) {
        this.showModal = false;
        this.getNeedApproval();
      }
      this.showMessageStatus(response);
      this.loading_request.edit = false;
    },
    async handleEditWorkshiftRequest() {
      this.loading_request.edit = true;
      const payload = {
        empchange_hr: {
          approved_by: "HR / Admin App",
          approved_date: getDate(),
          approved_hours: getCurrentTime(),
          status: this.data.hr.status,
        },
        empchange_fsuperior: {
          approved_by: "HR / Admin App",
          approved_date: getDate(),
          approved_hours: getCurrentTime(),
          status: this.data.fsuperior.status,
        },
        empchange_ssuperior: {
          approved_by: "HR / Admin App",
          approved_date: getDate(),
          approved_hours: getCurrentTime(),
          status: this.data.ssuperior.status,
        },
      };
      const response = await EditChangeWorkshiftAPI(
        this.data?.request_id,
        payload
      );
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      if (response.status === 200) {
        this.showModal = false;
        this.getNeedApproval();
      }
      this.showMessageStatus(response);
      this.loading_request.edit = false;
    },
    async handleEditStatus() {
      this.loading_request.edit = true;
      const payload = {
        empleave_status: this.detailLeave?.empleave_status,
      };
      const response = await EditStatusLeaveRequestAPI(
        this.detailLeave?._id,
        payload
      );
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      if (response.status === 200) {
        this.showModal = false;
        this.getNeedApproval();
      }
      this.showMessageStatus(response);
      this.loading_request.edit = false;
    },
  },
};
</script>

<style scoped>
table thead th,
table tbody tr td {
  padding: 1rem 2rem;
}
.custom-scrollbar::-webkit-scrollbar {
  height: 5px !important;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  border-radius: 20px;
  background-color: #c6c8cc;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: #a1a1a1;
}
.approved .bg-icon {
  background: rgb(220, 255, 220);
}
.approved svg {
  color: rgb(110, 197, 110);
}
.approved .indicator {
  background: rgb(110, 197, 110) !important;
}
.not-approved .bg-icon {
  background: rgba(255, 0, 0, 0.4);
}
.not-approved svg {
  color: rgb(239 68 68);
}
.not-approved .indicator {
  background: rgb(239 68 68) !important;
}

.pending svg {
  color: rgb(164, 164, 164);
}
.pending .indicator {
  background: rgb(164, 164, 164) !important;
}
</style>
